import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell } from 'recharts';

const MOOD_COLORS = {
  'Happy': '#4CAF50',
  'Neutral': '#FFC107',
  'Stressed': '#F44336',
};

const MoodDistributionChart = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="chart-loading">
        <p>Loading mood data...</p>
      </div>
    );
  }

  if (!data || Object.keys(data).length === 0) {
    return (
      <div className="no-data-message">
        <p>No mood data available. Submit daily scans with mood selection.</p>
      </div>
    );
  }

  // Transform object data to array for stacked bar chart
  // Create single bar with stacked segments
  const chartData = [{
    name: 'Mood',
    Happy: data.Happy || 0,
    Neutral: data.Neutral || 0,
    Stressed: data.Stressed || 0,
  }];

  const total = (data.Happy || 0) + (data.Neutral || 0) + (data.Stressed || 0);

  if (total === 0) {
    return (
      <div className="no-data-message">
        <p>No mood entries yet. Submit daily scans with mood to see distribution.</p>
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart
        data={chartData}
        margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
        layout="vertical"
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
        <XAxis 
          type="number"
          label={{ value: 'Count', position: 'insideBottom', offset: -10 }}
          tick={{ fontSize: 12 }}
        />
        <YAxis 
          type="category"
          dataKey="name"
          tick={{ fontSize: 12 }}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: 'white',
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            padding: '12px',
          }}
          formatter={(value) => [`${value} entries`, 'Count']}
        />
        <Legend 
          verticalAlign="top"
          height={36}
          iconType="square"
        />
        <Bar 
          dataKey="Happy" 
          stackId="mood"
          fill={MOOD_COLORS.Happy}
        />
        <Bar 
          dataKey="Neutral" 
          stackId="mood"
          fill={MOOD_COLORS.Neutral}
        />
        <Bar 
          dataKey="Stressed" 
          stackId="mood"
          fill={MOOD_COLORS.Stressed}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default MoodDistributionChart;
